
import React, { useState, useEffect } from "react";
import { Page, Grid, Card, Form, Button } from "tabler-react";
import SiteWrapper from "../../SiteWrapper";

import * as productServices from "../../store/services/productServices";
import { BACKENDURL } from "../../store/services/type";
import { ROLE_ADMIN } from "../../store/types";

import "../../index.css";


function ViewProduct(props) {

    const [ user ] = useState((localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))) || {});
    const [ loading, setLoading ] = useState(false);
    const [ product, setProduct ] = useState(null);
    const [ measurements, setMeasurements ] = useState([]);
    const [ measureUnit, setMeasureUnit ] = useState('in');
    const [ activeVariant, setActiveVariant ] = useState(-1);

    const cmToIn = (val) => val != null && val !== '' ? parseFloat((parseFloat(val) / 2.54).toFixed(2)) : '';
    const displayVal = (cmVal) => measureUnit === 'in' ? cmToIn(cmVal) : (cmVal ?? '');

    useEffect(() => {
        setLoading(true);

        productServices
            .getProduct(props.match.params.id)
            .then(( res ) => {
                const data = JSON.parse(res.data);
                setProduct(data.data);
                setMeasurements(data?.data?.measurements || []);
                setLoading(false);
            })
            .catch(err => setLoading(false));
    }, [props.match.params.id])

    return (
        <SiteWrapper loading={loading}>
            <Page.Content>
                <div className="page-header d-flex justify-content-between">
                    <h1 className="page-title">
                        Products
                    </h1>
                </div>

                <Grid.Row>
                    <Grid.Col>
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <Card.Title>
                                    {
                                        "Details"
                                    }
                                </Card.Title>

                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        props.history.push(`/products/${props.match.params.id}`);
                                    }}
                                >
                                    Edit
                                </Button>
                            </Card.Header>

                            { product?.variants?.length > 0 && (
                                <div style={{ borderBottom: '1px solid #e9ecef', padding: '0 16px', display: 'flex', alignItems: 'center', gap: 4 }}>
                                    <button type="button" onClick={() => setActiveVariant(-1)} style={{ padding: '10px 16px', border: 'none', background: 'none', borderBottom: activeVariant === -1 ? '2px solid #2B9A99' : '2px solid transparent', color: activeVariant === -1 ? '#2B9A99' : '#6c757d', fontWeight: activeVariant === -1 ? 600 : 400, fontSize: 13, cursor: 'pointer', marginBottom: -1 }}>Base</button>
                                    {product.variants.map((v, i) => (
                                        <button key={i} type="button" onClick={() => setActiveVariant(i)} style={{ padding: '10px 16px', border: 'none', background: 'none', borderBottom: activeVariant === i ? '2px solid #2B9A99' : '2px solid transparent', color: activeVariant === i ? '#2B9A99' : '#6c757d', fontWeight: activeVariant === i ? 600 : 400, fontSize: 13, cursor: 'pointer', marginBottom: -1 }}>{ v.label || `Colour ${i + 1}` }</button>
                                    ))}
                                </div>
                            )}

                            <Card.Body >

                                <Grid.Row className="pb-5">
                                    <Grid.Col width={ 12 }>
                                        <Grid.Row>
                                            <Grid.Col xl={ 4 } md={ 6 } width={ 12 } >
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="PRODUCT" >
                                                            <Form.StaticText>
                                                                { product?.product }
                                                                { product?.variants?.length > 0 && (
                                                                    <span style={{ display: 'inline-block', marginLeft: 8, padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600, backgroundColor: '#f0fafa', color: '#2B9A99' }}>Variable</span>
                                                                )}
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="PRICE" >
                                                            <Form.StaticText>
                                                                { (activeVariant >= 0 && product?.variants?.[activeVariant]?.price) || product?.price }
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="SKU" >
                                                            <Form.StaticText>
                                                                { product?.sku || '—' }
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="INTERNAL ID" >
                                                            <Form.StaticText>
                                                                { product?.unique_id }
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="CATEGORY" >
                                                            <Form.StaticText>
                                                                {
                                                                    product?.category?.category
                                                                }
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="URL" >
                                                            <Form.StaticText>
                                                                { (activeVariant >= 0 && product?.variants?.[activeVariant]?.url) || product?.url }
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                {
                                                    user?.type === ROLE_ADMIN && 
                                                    <Grid.Row>
                                                        <Grid.Col width={ 12 } >
                                                            <Form.Group label="DEALER" >
                                                                <Form.StaticText>
                                                                    {
                                                                        `${String(product?.user_id || "").padStart(4, '0')} - ${product?.dealer?.name || ""} ${product?.dealer?.last_name || ""}`
                                                                    }
                                                                </Form.StaticText>
                                                            </Form.Group>
                                                        </Grid.Col>
                                                    </Grid.Row>
                                                }
                                            </Grid.Col>
                                            <Grid.Col xl={ 4 } md={ 6 } width={ 12 } >
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="DESCRIPTION" className="text-wrap" >
                                                            <Form.StaticText>
                                                                {
                                                                    product?.description
                                                                }
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <Form.Group label="FEATURES" >
                                                            <Form.StaticText className="text-wrap">
                                                                {
                                                                    product?.features
                                                                }
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Grid.Col width={ 12 } >
                                                        <div className="d-flex align-items-center mb-3">
                                                            <span className="text-secondary mr-2" style={{ fontSize: 13 }}>cm</span>
                                                            <Form.Switch
                                                                name="dimensionUnit"
                                                                className="mx-2"
                                                                checked={measureUnit === 'in'}
                                                                onChange={(e) => setMeasureUnit(e.target.checked ? 'in' : 'cm')}
                                                            />
                                                            <span className="text-secondary" style={{ fontSize: 13 }}>inches</span>
                                                        </div>
                                                        <Form.Group label="DIMENSIONS">
                                                            <Form.StaticText className="text-wrap">
                                                                {`Width: ${displayVal(product?.width)}${measureUnit}`}
                                                                <br/>
                                                                {`Height: ${displayVal(product?.height)}${measureUnit}`}
                                                                <br/>
                                                                {`Depth: ${displayVal(product?.depth)}${measureUnit}`}
                                                                {product?.weight && (
                                                                    <>
                                                                        <br/>
                                                                        {`Weight: ${product.weight}kg`}
                                                                    </>
                                                                )}
                                                            </Form.StaticText>
                                                        </Form.Group>
                                                    </Grid.Col>
                                                </Grid.Row>
                                            </Grid.Col>
                                            <Grid.Col xl={ 4 } md={ 6 } width={ 12 } >
                                                <Form.Group label="IMAGES" >
                                                    <div className="image-view-container">
                                                        { (activeVariant >= 0 && product?.variants?.[activeVariant]?.images?.length > 0
                                                            ? product.variants[activeVariant].images
                                                            : product?.images || []
                                                        ).map((data, index) => (
                                                            <div key={ index } className="image-tile">
                                                                <img src={ `${BACKENDURL}storage/${data}` } alt="product" />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Form.Group>
                                            </Grid.Col> 
                                        </Grid.Row>
                                        <Form.Group label="MEASUREMENTS" >
                                            <Grid.Row>
                                                {
                                                    measurements?.map((data, index) => {
                                                        return (
                                                            <Grid.Col md={ 4 } width={ 12 } key={ index } className="mt-13" >
                                                                <div className="measurement-tile-header">
                                                                    {
                                                                        data.measurement
                                                                    }
                                                                </div>
                                                                <div className="measurement-tile-body">
                                                                    {`Min ${displayVal(data?.min)}${measureUnit} | Max ${displayVal(data?.max)}${measureUnit}`}
                                                                </div>
                                                            </Grid.Col>
                                                        )
                                                    })
                                                }
                                            </Grid.Row>
                                        </Form.Group>


                                    </Grid.Col>
                                </Grid.Row>

                            </Card.Body>
                        
                        </Card>
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        </SiteWrapper>
    )
}

export default ViewProduct;